import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";

import MainLayout from "../layouts/main";

import LoadingScreen from "../components/LoadingScreen/LoadingScreen";
import { useSelector } from "react-redux";
import useResponsive from "../hooks/useResponsive";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  const { role } = useSelector((state) => state.auth);

  const isDesktop = useResponsive("up", 960);

  return useRoutes([
    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: "/", element: <Home /> },
        { path: "login", element: role === "OPERATOR" || role === "SUPERVISOR"  ? <Navigate replace to={"/"} /> : <LoginPage /> },
        { path: "account-management", element: role === "OPERATOR" ? <AccountManagement /> : <Navigate replace to={"/"} /> },
        { path: "new-password", element: <NewPasswordPage /> },
        { path: "reset-password", element: <ResetPasswordPage /> },
        { path: "about-us", element: <AboutUs /> },
        { path: "legal-framework", element: <LegalFramework /> },
        { path: "user-manual", element: <UserManual /> },
        { path: "infracciones-guide", element: <InfraccionesGuide /> },
        { path: "resource-center", element: <ResourceCenter /> },
        { path: "detection", element: isDesktop ? <Detection /> :  <Navigate to="/detection-mobile" replace />},
        { path: "faq", element: <FAQ /> },
        { path: "check", element: <Check /> },
        { path: "check-mapping", element: <CheckMapping /> },
        { path: "jot-form", element: <JotForm /> },
        { path: "detection-mobile", element: isDesktop ? <Navigate to="/detection" replace />: <DetectionMobile /> },
        { path: "detail/:id", element: <Detail /> },

        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
    { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}

const LoginPage = Loadable(lazy(() => import("../pages/auth/LoginPage")));

const AccountManagement = Loadable(lazy(() => import("../pages/main/AccountManagement/AccountManagement")));

const NewPasswordPage = Loadable(
  lazy(() => import("../pages/auth/NewPasswordPage"))
);
const ResetPasswordPage = Loadable(
  lazy(() => import("../pages/auth/ResetPasswordPage"))
);

const Home = Loadable(lazy(() => import("../pages/main/Home/Home")));

const AboutUs = Loadable(lazy(() => import("../pages/main/AboutUs/AboutUs")));

const LegalFramework = Loadable(
  lazy(() => import("../pages/main/LegalFramework/LegalFramework"))
);

const UserManual = Loadable(
  lazy(() => import("../pages/main/UserManual/UserManual"))
);

const InfraccionesGuide = Loadable(
  lazy(() => import("../pages/main/InfraccionesGuide/InfraccionesGuide"))
);

const ResourceCenter = Loadable(
  lazy(() => import("../pages/main/ResourceCenter/ResourceCenter"))
);

const FAQ = Loadable(lazy(() => import("../pages/main/FAQ/FAQ")));

const Detection = Loadable(
  lazy(() => import("../pages/main/Detection/Detection"))
);

const DetectionMobile = Loadable(
  lazy(() => import("../pages/main/DetectionMobile/DetectionMobile"))
);

const Detail = Loadable(lazy(() => import("../pages/main/Detail/Detail")));

const Check = Loadable(lazy(() => import("../pages/main/Check/Check")));

const CheckMapping = Loadable(
  lazy(() => import("../pages/main/CheckMapping/CheckMapping"))
);

const JotForm = Loadable(lazy(() => import("../pages/main/JotForm/JotForm")));

const Page404 = Loadable(lazy(() => import("../pages/Page404/Page404")));
